import { Map } from 'eemovel-map-library';
import { useCallback, useEffect, useState } from 'react';
import { shoudUpdateMap } from '../../modules/dashboard/dataLayers/controllers/dataLayers.controller';

function useActionsOnMapDrag(enableHook = true, action?: () => void) {
  const [previousBounds, setPreviousBounds] = useState<
    google.maps.LatLngBounds | undefined
  >();

  const updateMap = useCallback(shoudUpdateMap, [enableHook]);

  useEffect(() => {
    const boundsChangedHandler = () => {
      const bounds = Map.map.getBounds();
      const shouldUpdateBounds = enableHook && bounds && updateMap();
      if (shouldUpdateBounds) {
        setPreviousBounds(bounds);
        action?.();
      }
    };
    const listener =
      Map?.map && Map.map.addListener('dragend', boundsChangedHandler);

    return () => {
      listener?.remove();
    };
  }, [enableHook]);

  return previousBounds;
}

export default useActionsOnMapDrag;
